import type { ApiRoute, NoPathParams, NoResponse } from "../../api"
import type { SetSelectedExteriorColorBody } from "../../common/colors/exteriorColor/SetSelectedExteriorColorBody"

export interface SetSelectedExteriorColorQueryParams {
	"inventory-id": string
}

export const setSelectedExteriorColorRoute: ApiRoute<
	NoPathParams,
	SetSelectedExteriorColorQueryParams,
	SetSelectedExteriorColorBody,
	NoResponse
> = {
	buildUrl: () => "/colors/exterior-color/selected",
	method: "post",
	path: "/colors/exterior-color/selected",
}
